export default __webpack_public_path__ + "assets/images/Alert-white-3a082ef333ef5476bd9051ed78b16fa0.svg";